import React, { useState } from 'react';
import { Link } from 'react-router';
import ReactTooltip from 'react-tooltip';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,

} from 'styled-dropdown-component';//DropdownDivider

import { UserProfile, IconIndropSetting, IconIndropSignout } from '../../img'; //IconCommission1

const ProfileMenu = ({
  handleLogout,
  userInfo,
  // fullName,
  // profile,
  // menuIu,
}) => {
  const [hidden, setHidden] = useState(true);
  return (
    <div className="nf-dropdown-wrapper">
      <div className="nf-dropdown">
        <Dropdown>
          <a id="dLabel" dropdowntoggle='' onClick={() => setHidden(!hidden)} data-target="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
            {
              userInfo && userInfo.iu ?
                <img className="circle-av" src={userInfo.iu} alt="notifly" />
                :
                <img className="circle-av" src={UserProfile} alt="notifly" />
            }
            {
              userInfo && userInfo.fn ?
                <div className="user-name">
                  <div className="dropd-username" data-tip data-for='user_name'> {userInfo.fn} </div>
                  <ReactTooltip id='user_name' aria-haspopup='true' role='example'>
                    <p>{userInfo.fn}</p>
                  </ReactTooltip>
                </div>
                :
                <div className="user-name">
                  <div className="dropd-username" data-tip data-for='user_name'> User </div>
                  <ReactTooltip id='user_name' aria-haspopup='true' role='example'>
                    <p>User</p>
                  </ReactTooltip>
                </div>
            }
            <span className="caret"></span>
          </a>
          <DropdownMenu hidden={hidden} toggle={() => setHidden(!hidden)} className="nf-dropdown-block nf-dropdown-userheader">
            <div className="dropdown-user-menu">
              <DropdownItem className="user-menu-submenu">
                <div>
                  <div className="indrop-left-icon">
                    <img className="" src={IconIndropSetting} alt="notifly" />
                  </div>
                  <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}profile`}>Profile</Link>
                </div>
              </DropdownItem>
              <DropdownItem className="user-menu-submenu">
                <div>
                  <div className="indrop-left-icon">
                    <img className="" src={IconIndropSetting} alt="notifly" />
                  </div>
                  <Link to={`${process.env.REACT_APP_ROUTE_PREFIX}feedback`}>Feedback</Link>
                </div>
              </DropdownItem>
              <DropdownItem className="user-menu-submenu">
                <div className="link-sout" onClick={() => handleLogout()}>
                  <div className="indrop-left-icon">
                    <img className="" src={IconIndropSignout} alt="notifly" />
                  </div>
                  <a>Sign Out</a>
                </div>
              </DropdownItem>
            </div>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div >
  );
};

export default ProfileMenu;


// WEBPACK FOOTER //
// ./src/components/Header/ProfileMenu.js